module.exports = __webpack_public_path__ + "img/4.55ffa50b.jpg";